export const USCapitolIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32" {...props}>
		<path
			fillRule="evenodd"
			d="M7.083 15c.505-2.987 3.239-5.21 6.546-5.827V1a1 1 0 0 1 1-1h5.486a1 1 0 0 1 1 1v.5h3.57l2.744 3.657-2.743 3.657H19.2V7.486H15.63V9c4.047.05 7.697 2.5 8.288 5.999H27a1 1 0 1 1 0 2h-1v2h4a1 1 0 1 1 0 2h-1.5v9H30a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2h1.5v-9H1a1 1 0 1 1 0-2h4v-2H4a1 1 0 1 1 0-2h3.083Zm2.053 0h12.728c-.591-2.163-3.055-4-6.364-4-3.309 0-5.773 1.837-6.364 4Zm9.979-9.514h-3.486V2h3.486v3.486ZM21.2 3.5h2.486l1.243 1.657-1.243 1.657H21.2V3.5ZM26.5 21v9H23v-9h3.5ZM24 19v-2H7v2h17Zm-3 2h-4.5v9H21v-9Zm-11 0h4.5v9H10v-9Zm-2 9v-9H4.5v9H8Z"
			clipRule="evenodd"
		/>
	</svg>
);
